<template>
    <div class="winHolidayWork">
        <el-backtop>
            <i class="el-icon-caret-top"></i>
        </el-backtop>
        <header>
            <div class="logo">
<!--                <h2>高招教育寒假作业</h2>-->
            </div>
        </header>
        <main>
            <div
                class="grades"
                :class="isScroll?'headFix':''">
                <div
                        class="gradeBox"
                        v-for="(item,index) in list"
                        :key="index"
                        @click="checkGrade(item.grade,item.gradeName)"
                        :class="grade===item.grade?'preGrade':''">
                    <span>{{item.gradeName}}</span>
                </div>
            </div>
            <div class="homeWorkList">
                <div
                    class="gradeList"
                    v-for="(work,index) in list"
                    :key="index">
                    <div
                        class="homeWorkBox"
                        v-for="(day,index) in work.dateList"
                        v-show="grade===work.grade"
                        :key="index">
                        <div class="left">
                            <div class="left-top">
                                <div class="circle"></div>
                            </div>
                            <div class="left-line"></div>
                        </div>
                        <div class="right">
                            <div class="day"><i class="el-icon-s-data"></i><span>第 {{day.num}} 天</span></div>
                            <div class="subjects">
                                <div
                                    class="subject"
                                    v-for="(item,index) in day.items"
                                    :key="index"
                                    @click="jumpPlayer(item.albumId,item.resourceId)">
                                    <div class="subjectLeft">
                                        <div class="picture">
                                            <img :src="item.picture" alt="">
                                        </div>
                                    </div>
                                    <div class="subjectRight">
                                        <div class="title">
                                            <b class="subjectName">【{{item.subjectName}}】</b>
                                            <span>{{item.title}}</span>
                                        </div>
                                        <div class="duration">(建议时长{{item.durationStr}})</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="madeWork">
                <el-button
                        @click="madeWork"
                        type="primary"
                        :disabled="isMadeWork">
                    {{buttonName}}
                </el-button>
            </div>
            <el-dialog
                 :visible.sync="madeWorkDialog"
                 width="40%"
                 :show-close="false">
                <div class="madeWork">
                    <el-form :model="madeWorkForm" :rules="rules" ref="ruleForm" label-width="160px">
                        <el-form-item label="作业开始时间" prop="beginTime">
                            <el-radio-group v-model="madeWorkForm.beginTimeType" @change="beginTimeChanged(madeWorkForm.beginTimeType)">
                                <el-radio label="立即布置"></el-radio>
                                <el-radio label="定时布置"></el-radio>
                            </el-radio-group>
                            <div class="block" >
                                <el-date-picker
                                        v-if="!madeWorkForm.isMadeNow"
                                        v-model="madeWorkForm.beginTime"
                                        type="datetime"
                                        placeholder="选择开始时间"
                                        @blur="checkBeginTime(madeWorkForm.beginTime)"
                                        default-time="12:00:00">
                                </el-date-picker>
                            </div>
                        </el-form-item>
                        <el-form-item label="作业结束时间" prop="endTime">
                            <div class="block">
                                <el-date-picker
                                    v-model="madeWorkForm.endTime"
                                    type="datetime"
                                    placeholder="选择结束时间"
                                    @blur="checkEndTime(madeWorkForm.endTime)"
                                    default-time="12:00:00">
                                </el-date-picker>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="madeWorkDialog = false">取 消</el-button>
                    <el-button type="primary" @click="confirmMadeWork('ruleForm')">确 定</el-button>
                </span>
            </el-dialog>
        </main>
        <aside>

        </aside>
    </div>
</template>

<script>
    import {checkIsWork, getWorkList, submitWork} from "../../../config";
    export default {
        name: "winHolidayWork",
        data() {
            return {
                isScroll: false,
                list: [],
                // 当前选择的年级
                grade: 2024,
                gradeName: '高一',
                isMadeWork: false,
                buttonName: '布置作业',
                madeWorkDialog: false,
                madeWorkForm: {
                    beginTimeType: '',
                    isMadeNow: true,
                    beginTime: '',
                    endTime: ''
                },
                rules: {
                    beginTime: [
                        { required: true, message: '请选择开始时间', trigger: 'blur' }
                    ],
                    endTime: [
                        { required: true, message: '请选择结束时间', trigger: 'change' }
                    ],
                }
            }
        },
        mounted() {
            Promise.all([
                this.defultWorkList(), // 查询数据列表
                this.defultCheckIsWork() // 检测是否布置了作业
            ]).then(() => {
                window.addEventListener("scroll",this.handleScroll);
            })
        },
        methods: {
            // 监听页面滚动事件
            handleScroll() {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > 425) {
                    this.isScroll = true;
                }else{
                    this.isScroll = false;
                }
            },
            // 检测是否布置了作业
            async defultCheckIsWork() {
              let res = await checkIsWork({
                  'grade': this.grade
              });
              if(res.status) {
                  if(res.data) {
                     this.isMadeWork = true;
                     this.buttonName = '已布置作业';
                  }else{
                      this.isMadeWork = false;
                      this.buttonName = '布置作业';
                  }
              }
            },
            // 查询数据列表
            async defultWorkList() {
                let res=await getWorkList();
                console.log(res.data);
                if(res.status) {
                    this.list = res.data;
                }
            },
            // 选择年级
            checkGrade(grade,gradeName) {
                this.grade = grade;
                this.gradeName = gradeName;
                this.defultCheckIsWork(); // 检测是否布置了作业
            },
            // 跳转视频播放
            jumpPlayer(albumId,videoId) {
                console.log(albumId, videoId);
                this.$router.push({
                    name:'teacherSourceVideo',
                    query:{
                       'albumId': albumId,
                        'type': '2',
                        'videoId': videoId
                    }
                })
            },
            // 布置作业
            madeWork() {
                this.madeWorkDialog = true;
            },
            // 选择开始时间
            beginTimeChanged(data) {
                if(data==='立即布置') {
                    this.madeWorkForm.beginTime = '';
                    let time = new Date();
                    this.madeWorkForm.isMadeNow = true;
                    let M = (time.getMonth()+1)<10? '0'+(time.getMonth()+1): (time.getMonth()+1);
                    let D = time.getDate()<10? '0'+time.getDate(): time.getDate();
                    let h = time.getHours()<10? '0'+time.getHours(): time.getHours();
                    let m = time.getMinutes()<10? '0'+time.getMinutes(): time.getMinutes();
                    let s = time.getSeconds()<10? '0'+time.getSeconds(): time.getSeconds();
                    this.madeWorkForm.beginTime = time.getFullYear()+'-'+M+'-'+D+' '+h+':'+m+':'+s;
                    console.log(this.madeWorkForm.beginTime);
                }else{
                    this.madeWorkForm.beginTime = '';
                    this.madeWorkForm.isMadeNow = false;
                }
            },
            checkBeginTime(time) {
                // 判断是否已经格式化
                let M = (time.getMonth()+1)<10? '0'+(time.getMonth()+1): (time.getMonth()+1);
                let D = time.getDate()<10? '0'+time.getDate(): time.getDate();
                let h = time.getHours()<10? '0'+time.getHours(): time.getHours();
                let m = time.getMinutes()<10? '0'+time.getMinutes(): time.getMinutes();
                let s = time.getSeconds()<10? '0'+time.getSeconds(): time.getSeconds();
                if(!time.length) {
                    // this.madeWorkForm.beginTime = time.getFullYear()+'-'+(time.getMonth()+1)+'-'+time.getDate()+' '+time.getHours()+':'+time.getMinutes()+':'+time.getSeconds();
                    this.madeWorkForm.beginTime = time.getFullYear()+'-'+M+'-'+D+' '+h+':'+m+':'+s;
                }
            },
            checkEndTime(time) {
                let M = (time.getMonth()+1)<10? '0'+(time.getMonth()+1): (time.getMonth()+1);
                let D = time.getDate()<10? '0'+time.getDate(): time.getDate();
                let h = time.getHours()<10? '0'+time.getHours(): time.getHours();
                let m = time.getMinutes()<10? '0'+time.getMinutes(): time.getMinutes();
                let s = time.getSeconds()<10? '0'+time.getSeconds(): time.getSeconds();
                if(!time.length) {
                    // this.madeWorkForm.endTime = time.getFullYear()+'-'+(time.getMonth()+1)+'-'+time.getDate()+' '+time.getHours()+':'+time.getMinutes()+':'+time.getSeconds();
                    this.madeWorkForm.endTime = time.getFullYear()+'-'+M+'-'+D+' '+h+':'+m+':'+s;
                }
            },
            // 确认布置作业
            confirmMadeWork(formName) {
                console.log(this.madeWorkForm);
                this.$refs[formName].validate((valid) => {
                    console.log(this.grade, this.gradeName, this.madeWorkForm.beginTime, this.madeWorkForm.endTime);
                    if (valid) {
                        submitWork({
                            "grade": this.grade,
                            "gradeName": this.gradeName,
                            "startTime": this.madeWorkForm.beginTime,
                            "endTime": this.madeWorkForm.endTime
                        }).then(res => {
                            if(res.status) {
                                this.$message('布置成功');
                            }
                        });
                        this.madeWorkDialog = false;
                    } else {
                        return false;
                    }
                });
            }

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../style/winHolidayWork.scss";
    header{
        div.logo{
            background-image: url(../../../assets/img/homeworkBg.png);
            background-repeat: no-repeat;
            background-size: contain;
            background-position: top center;
            height: 420px;
        }
    }
</style>